export { getCompanyConfig } from './getCompanyConfig';
export { lineClamp } from './lineClamp';
